import React from "react";
import {
  FunctionField,
  ReferenceField,
  TextField,
  DateField,
  Labeled,
} from "react-admin";

import {
  CardContent,
  Grid,
  Card,
} from "@material-ui/core";

import {
  isEmpty,
  prop,
  isNil,
} from "ramda";
import moment from "moment";

const shirtSize = { 1: "S (EU) | XS (US)", 2: "M (EU) | S (US)", 3: "L (EU) | M (US)", 4: "XL (EU) | L (US)", 5: "XXL (EU) | XL (US)", 6: "XXXL (EU) | XXL (US)" };

export const PersonalInformationField = props => {
  const { record, passenger } = props;
  const booking = prop('booking', record);
  const passengerFirstName = prop('p_first_name', booking);
  const hasPassenger = !isNil(passengerFirstName) && !isEmpty(passengerFirstName);
  const prefix = passenger ? 'p_' : 'r_';

  if (passenger && !hasPassenger) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        <h3>{passenger ? "Passenger Information" : "Rider Information"}</h3>
        <Grid container spacing={16}>
          <Grid item xs={2}>
            <Labeled label="Name">
              <FunctionField
                {...props}
                render={(rental) => {
                  const firstName = prop(`${prefix}first_name`, rental.booking);
                  const lastName = prop(`${prefix}last_name`, rental.booking);
                  return `${firstName} ${lastName}`;
                }}
              />
            </Labeled>
          </Grid>
          <Grid item xs={1}>
            <Labeled label="Age" >
              <FunctionField
                {...props}
                render={(rental) => {
                  const birthday = prop(`${prefix}birthday`, rental.booking);
                  return `${Math.floor(
                    moment
                      .duration(moment().diff(moment(birthday)))
                      .as("years", true)
                  )}`;
                }}
              />
            </Labeled>
          </Grid>
          <Grid item xs={2}>
            <Labeled label="Date of Birth" >
              <DateField
                {...props}
                source={`booking.${prefix}birthday`}
                options={{
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }}
              />
            </Labeled>
          </Grid>
          <Grid item xs={1}>
            <Labeled label="Height" >
              <FunctionField
                {...props}
                render={(rental) => {
                  const unitField = prop(`${prefix}height_unit`, rental.booking);
                  const unit = unitField === 1 ? "m" : "ft";
                  return `${prop(`${prefix}height`, rental.booking)} ${unit}`;
                }}
              />
            </Labeled>
          </Grid>
          <Grid item xs={2}>
            <Labeled label="Weight" >
              <FunctionField
                {...props}
                render={(rental) => {
                  const unitField = prop(`${prefix}weight_unit`, rental.booking);
                  const unit = unitField === 1 ? "kg" : "pounds";
                  return `${prop(`${prefix}weight`, rental.booking)} ${unit}`;
                }}
              />
            </Labeled>
          </Grid>
          <Grid item xs={2}>
            <Labeled label="T-shirt size" >
              <FunctionField
                {...props}
                render={(rental) => {
                  const shirtField = prop(`${prefix}shirt`, rental.booking);
                  return shirtField ? prop(shirtField, shirtSize) : 'N/A';
                }}
              />
            </Labeled>
          </Grid>
        </Grid>
        <Grid container spacing={16}>
          <Grid item xs={2}>
            <Labeled label="Nationality" >
              <TextField {...props} source={`booking.${prefix}nationality`} />
            </Labeled>
          </Grid>
          <Grid item xs={2}>
            <Labeled label="Nickname" >
              <TextField {...props} source={`booking.${prefix}nickname`} />
            </Labeled>
          </Grid>
          <Grid item xs={3}>
            <Labeled label="Passport/ID" >
              <FunctionField
                {...props}
                render={(rental) => {
                  const passport = prop(`${prefix}passport`, rental.booking);
                  return isEmpty(passport) || isNil(passport)
                    ? "N/A"
                    : passport;
                }}
              />
            </Labeled>
          </Grid>
          <Grid item xs={2}>
            <Labeled label="Occupation" >
              <TextField {...props} source={`booking.${prefix}occupation`} />
            </Labeled>
          </Grid>
        </Grid>
        <Grid container spacing={16}>
          <Grid item xs={2}>
            <Labeled label="Country">
              <ReferenceField
                {...props}
                source={`booking.${prefix}country_id`}
                reference="countries"
                linkType={false}
                allowEmpty={true}
              >
                <TextField source="country" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid item xs={3}>
            <Labeled label="Address" >
              <FunctionField
                {...props}
                render={(rental) => {
                  const address = prop(`${prefix}address`, rental.booking);
                  const zip = prop(`${prefix}zip`, rental.booking);
                  const city = prop(`${prefix}city`, rental.booking);
                  return `${address} ${zip}, ${city}`;
                }}
              />
            </Labeled>
          </Grid>
          <Grid item xs={2}>
            <Labeled label="Phone Number">
              <TextField {...props} source={`booking.${prefix}home_phone`} />
            </Labeled>
          </Grid>
          <Grid item>
            <Labeled label="Languages Spoken" >
              <FunctionField
                {...props}
                render={(r) => {
                  return `
                    ${prop(`${prefix}english`, r.booking) ? "English" : ""}
                    ${prop(`${prefix}spanish`, r.booking) ? "Spanish" : ""}
                    ${prop(`${prefix}french`, r.booking) ? "French" : ""}
                    ${prop(`${prefix}german`, r.booking) ? "German" : ""}
                    ${prop(`${prefix}portuguese`, r.booking) ? "Portuguese" : ""}`;
                }}
              />
            </Labeled>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};


// WEBPACK FOOTER //
// ./src/components/PersonalInformationField.js